"use strict";

var MARKUP_SECTION_TYPE = 1;
exports.MARKUP_SECTION_TYPE = MARKUP_SECTION_TYPE;
var IMAGE_SECTION_TYPE = 2;
exports.IMAGE_SECTION_TYPE = IMAGE_SECTION_TYPE;
var LIST_SECTION_TYPE = 3;
exports.LIST_SECTION_TYPE = LIST_SECTION_TYPE;
var CARD_SECTION_TYPE = 10;
exports.CARD_SECTION_TYPE = CARD_SECTION_TYPE;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-text-renderer/dist/commonjs/mobiledoc-text-renderer/utils/section-types.js
// module id = 541
// module chunks = 0